// Hocs
import asyncRoute from '../AsyncRoute'

import { RECOMMENDATIONS_ROUTE_URLS } from '../constants'
import getRequestName from '../components/getRequestName'

// Exports
export function getComponent ({store}) {
  return new Promise((resolve) => {
    require.ensure([], (require) => {
      const View = require('hfty-recommendations-dom').RecommendationsManager
      const requestInfoMaskHoc = require('fc-requests').requestInfoMaskHoc
      const requestInfo$ = require('fc-requests').getFilteredRequestsInProgress$(RECOMMENDATIONS_ROUTE_URLS)

      resolve(requestInfoMaskHoc({
        requestInfo$,
        getRequestName,
      })(View))

    /* Webpack named bundle   */
    }, 'recommendations')
  })
}

export default asyncRoute({getComponent, reducers: []})
